<template>
    <svg
        class="sps-header-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M5 8.25L10 13L15 8.25"
            :stroke="color || 'currentColor'"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "MinimizeIcon",
    props: ["color"],
};
</script>
<style scoped>
.sps-header-icon {
    display: block;
    color: var(--header-text-color);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/svg/components/MinimizeIcon.vue